import { render, staticRenderFns } from "./AmountTypeItem.vue?vue&type=template&id=627dd762&scoped=true&"
import script from "./AmountTypeItem.vue?vue&type=script&lang=js&"
export * from "./AmountTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./AmountTypeItem.vue?vue&type=style&index=0&id=627dd762&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627dd762",
  null
  
)

export default component.exports